import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox"
  ]

  static values = {
    passedDueDate: Boolean
  }

  updateGroupClass () {
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked)
    if (allChecked) {
      this.element.classList.remove('item-group--warning')
      this.element.classList.add('item-group--success')
    } else if (this.passedDueDateValue) {
      this.element.classList.remove('item-group--success')
      this.element.classList.add('item-group--warning')
    }
  }
}
